export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_17.255ab36b.jpg";